module.exports = __webpack_public_path__ + "img/gq.d0321a0a.png";